import React, { useState } from 'react';
import { Link } from 'react-router-dom'; // 👈 make sure this import is present
import {
  FaLaptopCode, FaWordpress, FaBuilding, FaShoppingCart, FaServer,
} from 'react-icons/fa';
import {
  MdPhoneIphone, MdGroupWork, MdSchool,
} from 'react-icons/md';
import {
  SiGoogleanalytics, SiGoogletagmanager, SiContentful, SiFacebook,
} from 'react-icons/si';

const Card = ({ children, className = '' }) => (
  <div className={`rounded-2xl shadow-md p-4 bg-white ${className}`}>
    {children}
  </div>
);

const CardContent = ({ children }) => <div>{children}</div>;

const panelThemes = {
  theme1: {
    bg: '#0a3c6d',
    text: 'text-white',
    border: 'border-[#0a3c6d]',
    iconColor: '#0a3c6d',
  },
  theme2: {
    bg: '#ff9b00',
    text: 'text-white',
    border: 'border-[#ff9b00]',
    iconColor: '#ff9b00',
  },
  theme3: {
    bg: '#8cc540',
    text: 'text-white',
    border: 'border-[#8cc540]',
    iconColor: '#8cc540',
  },
};

const iconsByTheme = {
  theme1: [FaLaptopCode, MdPhoneIphone, MdGroupWork, MdSchool],
  theme2: [FaWordpress, FaBuilding, FaShoppingCart, FaServer],
  theme3: [SiGoogleanalytics, SiGoogletagmanager, SiContentful, SiFacebook],
};

const mainIconByTheme = {
  theme1: FaLaptopCode,
  theme2: FaLaptopCode,
  theme3: SiGoogleanalytics,
};

const ServiceSlider = ({ slides }) => {
  const [activeSlide, setActiveSlide] = useState(0);
  const slide = slides[activeSlide];
  const theme = panelThemes[slide.panelTheme];
  const MainIcon = mainIconByTheme[slide.panelTheme];

  return (

    <div className="w-[100%] max-w-[1800px] mx-auto px-4">
      <h2 className="text-3xl font-bold text-center text-[#0a3c6d] mb-6">
    Our Core Services
  </h2>

      {/* Slide Container */}
      <div className="transition-all duration-500 ease-in-out w-full border-2 rounded-2xl shadow-md p-4" style={{ borderColor: theme.border.replace('border-', '') }}>
        <div className="grid md:grid-cols-3 gap-6">
          {/* Main Feature */}
          <div className="md:col-span-1 flex flex-col items-center text-center">
            <div className={`p-6 rounded-xl w-full h-full`} style={{ backgroundColor: theme.bg }}>
              <div className="flex flex-col items-center justify-center">
                <MainIcon size={48} color="white" className="mb-3" />
                <h3 className="text-2xl font-bold text-white">{slide.mainFeature.title}</h3>
                <p className="mt-2 italic text-white">{slide.mainFeature.subtitle}</p>
                <p className="mt-3 text-sm text-white">{slide.mainFeature.desc}</p>
           <Link
  to={slide.mainFeature.link}
  className="mt-3 text-white hover:underline text-sm"
>
  Read More →
</Link>
              </div>
            </div>
          </div>

          {/* Minor Features */}
          <div className="md:col-span-2 grid sm:grid-cols-2 gap-4">
            {slide.features.map((feature, idx) => {
              const Icon = iconsByTheme[slide.panelTheme][idx];
              return (
                
                <Card key={idx} className="rounded-xl border hover:shadow-lg transition text-center">
                  <CardContent className="p-4 space-y-2">
                    <div className="flex flex-col items-center justify-center">
                      <Icon size={32} color={theme.iconColor} className="mb-2" />
                      <p className="font-semibold">{feature.title}</p>
                      <p className="text-sm text-gray-600">{feature.desc}</p>
                      {/* Add your Read More link here */}
      <Link
        to={feature.link}
        className="mt-3 text-blue-600 hover:underline text-sm"
      >
        Read More →
      </Link>
                    </div>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </div>

      {/* Numbered Navigation Dots */}
      <div className="flex justify-center mt-6 space-x-2">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setActiveSlide(index)}
            className={`w-8 h-8 rounded-full text-white font-bold transition duration-300 ${
              index === activeSlide ? 'bg-blue-700 scale-110' : 'bg-gray-300 text-black'
            }`}
          >
            {index + 1}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ServiceSlider;
